import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

import { Box, Card } from "@mui/material";

import PictureSelector from "components/PicutreSelector/PictureSelector";
import ProductInfoOil from "components/ProductInfo/ProductInfoOil";

export default function WebViewOil({ data, dataURL }) {
    const [selected, setSelected] = useState(0);

    const text = {
        fontFamily: "Poppins, sans-serif",
    };

    return (
        <Box
            component="div"
            sx={{ display: { xs: "none", sm: "block" } }}
            style={{
                paddingLeft: "30px",
                paddingRight: "30px",
                paddingTop: "30px",
                paddingBottom: "30px",
            }}
        >
            <div
                style={{
                    display: "flex",
                }}
            >
                <PictureSelector
                    picturesURL={dataURL}
                    handleSelector={(index) => setSelected(index)}
                />
                <Box
                    sx={{
                        width: { xs: "100%", md: "750px" },
                        display: { xs: "block", md: "flex" },
                    }}
                    component="div"
                    style={{
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    {dataURL !== null && (
                        <Box
                            component="img"
                            src={dataURL[selected]}
                            alt="car"
                            sx={{
                                width: { xs: "100%", md: "500px" },
                                height: { xs: "250px", md: "500px" },
                            }}
                            style={{
                                cursor: "pointer",
                            }}
                        />
                    )}
                    <Box
                        sx={{
                            display: { xs: "flex", md: "flex" },
                            width: { xs: "100%", md: "500px" },
                            fontSize: { xs: "12px", md: "15px" },
                        }}
                        component={Card}
                        style={{ marginTop: "30px", marginBottom: "30px" }}
                    >
                        <div
                            style={{
                                textAlign: "left",
                                padding: "20px",
                                ...text,
                            }}
                        >
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                rehypePlugins={[rehypeRaw]}
                            >
                                {data.description}
                            </ReactMarkdown>
                        </div>
                    </Box>
                    CÓDIGO UPC: {data?.upcCode}
                </Box>

                <Box
                    component="div"
                    sx={{
                        display: { xs: "none", md: "flex" },
                    }}
                    style={{
                        height: "100%",
                        width: "35%",
                        backgroundColor: "white",
                    }}
                >
                    <ProductInfoOil data={data} />
                </Box>
            </div>
        </Box>
    );
}